import { createDeliveryRoute, type DeliveryRoute } from '../Delivery/shared';

/**
 * Sub-routes under `/my-packs`. The shape and behaviour are shared with the
 * standalone `/shipping` page, so the router is produced by the common
 * `createDeliveryRoute` factory — see `Delivery/shared/createDeliveryRoute.ts`.
 *
 *   /my-packs                       → { kind: 'index' }     — tabs page
 *   /my-packs/deliveries/new        → { kind: 'delivery-new' } — create form
 *   /my-packs/deliveries/:id        → { kind: 'delivery-show', id }
 */
export type MyPacksRoute = DeliveryRoute;

const router = createDeliveryRoute('/my-packs');

export const parseMyPacksRoute = router.parse;
export const myPacksRouteToPath = router.toPath;
export const pushMyPacksRoute = router.push;
export const replaceMyPacksRoute = router.replace;
export const useMyPacksRoute = router.useRoute;
